module.exports = __webpack_public_path__ + "img/temb9.99a88a16.png";